import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import { segment } from '@actions/analytics';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { nFormatter } from '@utils/textHelper';
import { useIsMobile } from '@stores/AppCommonData';
import { EDUCATOR_HATS_VIEWED } from '@constants/segment';
import useEducatorDetailsSegmentData from '@hooks/useEducatorDetailsSegmentData';
import useProfile from '@api/hooks/profile/useProfile';
import { Typography } from 'aquilla/core/atoms/Typography';
import Image from '@base/Image';

const EducatorDedications = Dynamic(() => import('./EducatorDedications'));

const StatsWrapper = styled.div``;
const Stats = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  cursor: ${({ $isEducatorOrIsModerator }) =>
    $isEducatorOrIsModerator ? 'pointer' : 'default'};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_2B};
    justify-content: space-between;
    align-items: center;
  }
`;

const Container = styled.div`
  position: absolute;
  right: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
  border: 1.2px solid #e9eef2;
  border-radius: 92px;
  width: 42px;
  justify-content: center;
  height: ${Spacings.SPACING_6B};
  background: var(--color-base-1);
  z-index: 1;
  ${mediaQuery.uptoTablet} {
    right: ${Spacings.SPACING_3B};
    width: 35px;
    height: 20px;
    margin-left: -${Spacings.SPACING_5B};
  }
`;

const Value = styled(Typography)`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.ULTRA_SMALL};
  color: var(--color-text-primary);
  ${mediaQuery.uptoMobile} {
    margin-bottom: 0;
    font-size: 8px;
  }
`;

const Label = styled(Typography)`
  font-size: ${Fonts.ULTRA_SMALL};
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_3B};
  margin-bottom: 4px;
  text-transform: uppercase;

  ${mediaQuery.uptoTablet} {
    font-size: 10px;
  }
`;

const Hats = styled.div`
  display: flex;

  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const Hat = styled.div`
  height: ${Spacings.SPACING_6B};
  & :not(:first-of-type) {
    margin-left: -${Spacings.SPACING_2B};
  }

  ${mediaQuery.uptoTablet} {
    height: ${Spacings.SPACING_18};
  }
`;

const EducatorDedicationStatsNew = ({ username }) => {
  const isMobile = useIsMobile();
  const { profileData: profileInfo } = useProfile(username);
  const {
    isEducator,
    isModerator,
    dedicationsCount: totalDedications,
    uid: educatorUID
  } = profileInfo;

  const segmentData = useEducatorDetailsSegmentData({
    educatorProfile: profileInfo
  });

  const [showDedications, setShowDedications] = useState(false);

  const label = 'Dedications';
  const value = nFormatter(totalDedications);

  const isEducatorOrIsModerator = isEducator || isModerator;

  const onClickDedications = () => {
    setShowDedications(true);
    segment.track(EDUCATOR_HATS_VIEWED, {
      ...segmentData,
      last_primary_source_secion: 'Educator Header'
    });
  };
  const onCloseDedicationsDrawer = () => setShowDedications(false);

  const hasDedications = totalDedications > 0;

  if (isEducator && totalDedications > 0 && true)
    return (
      <>
        <StatsWrapper>
          <Label>{label}</Label>
          <Stats
            onClick={isEducatorOrIsModerator ? onClickDedications : undefined}
            $isEducatorOrIsModerator={isEducatorOrIsModerator}
          >
            {hasDedications && (
              <>
                <Hats>
                  <Hat>
                    <Image
                      src="educator/educatorBadge/educatorBadge2.svg"
                      alt="educator badge2"
                      height={isMobile ? 18 : 24}
                      width={isMobile ? 18 : 24}
                    />
                  </Hat>
                  <Hat>
                    <Image
                      src="educator/educatorBadge/educatorBadge1.svg"
                      alt="educator badge1"
                      height={isMobile ? 18 : 24}
                      width={isMobile ? 18 : 24}
                    />
                  </Hat>
                </Hats>
              </>
            )}
            <Container>
              <Value>{value}</Value>
            </Container>
          </Stats>
        </StatsWrapper>
        {showDedications && (
          <EducatorDedications
            showDedications={showDedications}
            username={username}
            educatorUID={educatorUID}
            onCloseDedications={onCloseDedicationsDrawer}
          />
        )}
      </>
    );
  return null;
};
export default EducatorDedicationStatsNew;

EducatorDedicationStatsNew.propTypes = {
  username: PropTypes.string.isRequired
};
